import { Component } from 'react'
import { Identifier, Names } from '../helpers'
import { FaFemale, FaMale } from 'react-icons/fa'
import { LiaUserCheckSolid, LiaUserSlashSolid } from 'react-icons/lia'
import moment from 'moment'
import './resource.css'
import '../containers/all.css'

class PatientCard extends Component {

    handleSelected() {
        this.props.onSelect(this.props.patient.id)
    }

    render() {
        return <div className='Res-Container Res-Patient' onClick={() => this.handleSelected()}>
            <div className='Res-Row Res-Flex-Spread'>
                <div>
                    <div className={`Res-Icon`}>{this.props.patient.gender === 'female' ? <FaFemale /> : <FaMale />}</div>
                    <div className='Res-Icon-Label'>{this.props.patient.gender === 'female' ? 'Female' : "Male"}</div>
                </div>
                <div>
                    <div className={`Res-Icon ${this.props.patient.active ? 'Res-Icon-Active' : 'Res-Icon-Inactive'}`}>{this.props.patient.active ? <LiaUserCheckSolid /> : <LiaUserSlashSolid />}</div>
                    <div className='Res-Icon-Label'>{this.props.patient.active ? 'Active' : "Inactive"}</div>
                </div>
            </div>
            <div className='Res-Row Res-Title Res-Flex'>
                <div>{this.props.patient.name ? Names(this.props.patient.name) : 'Some Loser'}</div>
            </div>
            <div className='Res-Row Res-Detail'>{`DOB ${moment(this.props.patient.birthDate).format('ll')}`}</div>
            {this.props.patient.identifier && <div className='Res-Row Res-Detail'>{Identifier(this.props.patient.identifier)}</div>}
        </div >
    }
}

export default PatientCard